import { Service } from './service.model';
import { RoomBooking } from './room-booking.model';
import { CourseInstance } from '../training';

export class ServiceBooking {
  courseInstance?: CourseInstance | string;

  createdAt?: string;

  date: string;
  id?: number;
  quantity: number;

  relateTo?: string;
  roomBooking?: RoomBooking | string;

  service: Service | string;
  updatedAt?: string;

  constructor(values= {}) {
    Object.assign(this, values);
  }
}
